import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';
import { ImarktHeaderComponentModule } from "../../components/imarkt-header/imarkt-header.module";
import { ImarktFooterComponentModule } from "../../components/imarkt-footer/imarkt-footer.module";

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    IonicPageModule.forChild(HomePage),
    ImarktHeaderComponentModule,
    ImarktFooterComponentModule
  ],
  exports: [
    HomePage
  ]
})
export class HomePageModule { }



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts